var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDomainFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 31,
    viewBox: "0 0 40 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8281 0H1.17188C0.515547 0 0 0.515547 0 1.17187V7.03125L2.34375 9.375H37.6562L40 7.03125V1.17187C40 0.515547 39.4845 0 38.8281 0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 4.6875C6.58469 4.6875 7.10938 4.16281 7.10938 3.51562C7.10938 2.86844 6.58469 2.34375 5.9375 2.34375C5.29031 2.34375 4.76562 2.86844 4.76562 3.51562C4.76562 4.16281 5.29031 4.6875 5.9375 4.6875ZM10.625 4.6875C11.2722 4.6875 11.7969 4.16281 11.7969 3.51562C11.7969 2.86844 11.2722 2.34375 10.625 2.34375C9.97781 2.34375 9.45312 2.86844 9.45312 3.51562C9.45312 4.16281 9.97781 4.6875 10.625 4.6875ZM15.3125 4.6875C15.9597 4.6875 16.4844 4.16281 16.4844 3.51562C16.4844 2.86844 15.9597 2.34375 15.3125 2.34375C14.6653 2.34375 14.1406 2.86844 14.1406 3.51562C14.1406 4.16281 14.6653 4.6875 15.3125 4.6875ZM0 7.03125V29.2969C0 29.9532 0.515547 30.4688 1.17188 30.4688H7.60164C7.3818 29.6993 7.26312 28.9154 7.19063 28.125H9.55695C9.64992 28.9227 9.80258 29.7133 10.0859 30.4688H14.3516C14.2579 29.7188 14.2423 28.9168 14.2109 28.125H16.5209C16.5537 28.9227 16.6085 29.7133 16.7187 30.4688H23.2812C23.3914 29.7133 23.4462 28.9227 23.479 28.125H25.789C25.7577 28.9168 25.742 29.7188 25.6484 30.4688H29.9374C30.2062 29.7255 30.3548 28.9321 30.4459 28.125H32.8102C32.7381 28.9249 32.6192 29.7114 32.3984 30.4688H38.8281C39.4845 30.4688 40 29.9532 40 29.2969V7.03125H0Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8359 21.8437C31.8125 21.8203 31.8125 21.7968 31.8125 21.7734C31.7892 21.7266 31.7423 21.6797 31.7188 21.6093C29.6797 17.1562 25.203 14.0625 20 14.0625C14.797 14.0625 10.3203 17.1562 8.28125 21.6093C8.25781 21.6797 8.21086 21.7266 8.18758 21.7734C8.18758 21.7968 8.18758 21.8203 8.16414 21.8437C7.4843 23.3905 7.10938 25.1484 7.10938 26.9531C7.10938 28.1484 7.27344 29.3203 7.60164 30.4687H10.086C9.66414 29.3438 9.45312 28.1484 9.45312 26.9531C9.45312 25.7109 9.66414 24.539 10.0625 23.4375H14.3516C14.2109 24.5859 14.1405 25.7812 14.1405 26.9531C14.1405 28.1484 14.2109 29.3438 14.3516 30.4687H16.7187C16.5548 29.3438 16.4844 28.1484 16.4844 26.9531C16.4844 25.6876 16.5548 24.5157 16.7187 23.4375H23.2812C23.4452 24.5157 23.5155 25.6876 23.5155 26.9531C23.5155 28.1484 23.4452 29.3438 23.2812 30.4687H25.6484C25.789 29.3438 25.8594 28.1484 25.8594 26.9531C25.8594 25.7812 25.789 24.5859 25.6484 23.4375H29.9374C30.3359 24.539 30.5468 25.7109 30.5468 26.9531C30.5468 28.172 30.3358 29.3673 29.9374 30.4687H32.3984C32.7266 29.3438 32.8906 28.172 32.8906 26.9531C32.8906 25.1484 32.5157 23.3905 31.8359 21.8437ZM14.75 21.0937H11.2344C12.4297 19.3359 14.1171 17.953 16.1094 17.1563C15.5235 18.2577 15.0782 19.6172 14.75 21.0937ZM17.1407 21.0937C17.8673 18.1171 19.0624 16.4062 20 16.4062C20.9376 16.4062 22.1327 18.1171 22.8593 21.0937H17.1407ZM25.25 21.0937C24.9219 19.6172 24.4766 18.2577 23.8906 17.1563C25.8829 17.953 27.5703 19.3359 28.7656 21.0937H25.25Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 20,
    y1: 9.375,
    x2: 20,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 20,
    y1: 30.4688,
    x2: 20,
    y2: 2.34375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBCBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 20,
    y1: 30.4687,
    x2: 20,
    y2: 14.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainFilter);
export default __webpack_public_path__ + "static/media/domain-filter.1f866ab4e337e7ff3da95c63dd00328a.svg";
export { ForwardRef as ReactComponent };